
// frontend/geopolitikia/src/components/LoadingOverlay.jsx
import React from 'react';
import { Bot } from 'lucide-react';

const LoadingOverlay = ({ loading, chatStatus }) => {
  if (!loading) return null;

  return (
    <div className="overlay">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-400 mx-auto mb-4"></div>
        <p className="text-slate-300 text-lg">Chargement...</p>
        {chatStatus && (
          <div className="flex gap-3">
            <div className="w-8 h-8 bg-gradient-to-br from-blue-500 to-purple-600 rounded-full flex items-center justify-center">
              <Bot size={16} className="text-white" />
            </div>
            <div className="bg-gradient-to-br from-slate-700 to-slate-800 p-3 rounded-2xl">
              <div className="flex items-center gap-2 text-slate-300">
                <div className="w-2 h-2 bg-blue-400 rounded-full animate-pulse"></div>
                <span>{chatStatus}</span>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default LoadingOverlay;
